import config from "@/config";
import http from "@/utils/request";

export default {
	// 上传凭证
	createAttachePerformanceRemark: {
		url: `${config.API_URL}/admin/report/createAttachePerformanceRemark`,
		name: "上传凭证",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// 查看凭证列表
	getAttachePerformanceRemarkList: {
		url: `${config.API_URL}/admin/report/getAttachePerformanceRemarkList`,
		name: "查看凭证列表",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// B/C端客户复购情况统计
	bcTotal: {
		url: `${config.API_URL}/admin/report/bcTotal`,
		name: "B/C端客户复购情况统计",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// B/C端客户复购情况明细列表
	bcTotalList: {
		url: `${config.API_URL}/admin/report/bcTotalList`,
		name: "B/C端客户复购情况明细列表",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// B/C端商品数量金额购买人数排行榜
	bcGoodsNumPriceTop: {
		url: `${config.API_URL}/admin/report/bcGoodsNumPriceTop`,
		name: "B/C端商品排行榜",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
};
